// 系统通知路由
const message = {
    path: 'message',
    component: () => import('@/components/RouterView'),
    meta: {title: '系统通知'},
    children: [
        {
            path: '',
            component: () => import('@/views/manage/message'),
            meta: { title: '系统通知'},
        },
    ]
}

export default message